import { useRouteContext } from "@tanstack/react-router";

export const useAuthCheck = () => {
  const { accessToken, isAuthenticated } = useRouteContext({
    from: "__root__",
  });

  return {
    accessToken,
    isAuthenticated: isAuthenticated(),
  };
};
